/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentTheme } from '../../stores/selectors/theme.selector';
import { Label, LabelType } from './Label.component';
import { ColorType, getHexColorByType } from './shared/Colors.g';

interface InputProps {
  disableLabel?: string;
  enableLabel?: string;
  labelColor?: ColorType;
  value?: boolean;
  onChange?: Function;
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  hideLabel?: boolean;
  switchClass?: string;
  switchBtnClass?: string;
  translateClass?: string;
}

export const Switch = memo(
  ({
    disableLabel = 'Off',
    enableLabel = 'On',
    labelColor = ColorType.BLACK,
    value = false,
    onChange,
    className = '',
    disabled = false,
    dataTestId,
    hideLabel = false,
    switchClass = 'w-10 h-5',
    switchBtnClass = 'w-4 h-4 left-0.5 top-0.5',
    translateClass = 'translate-x-5',
  }: InputProps) => {
    const theme = useSelector(getCurrentTheme);

    const updateChecked = () => {
      !disabled && onChange && onChange(!value);
    };

    // Accessibility Logic: Handles keyboard interaction to update check
    const switchToggleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        updateChecked();
      }
    };

    return (
      <div className={`flex flex-row items-center gap-2 ${className}`}>
        <div
          data-testid={dataTestId}
          role='button'
          tabIndex={0}
          onClick={updateChecked}
          onKeyDown={switchToggleKeyDown}
          className={`relative ${switchClass} rounded-full flex items-center ${
            !disabled && 'cursor-pointer'
          }`}
          style={{
            backgroundColor:
              disabled || !value ? getHexColorByType(ColorType.GREY2) : theme.brand_2,
          }}
        >
          <div
            className={`${switchBtnClass} rounded-full bg-white absolute transform transition-transform ${
              value ? `${translateClass}` : ''
            }`}
          />
        </div>
        {!hideLabel && (
          <span className='self-center'>
            <Label
              text={!value ? disableLabel : enableLabel}
              type={LabelType.BODY3}
              color={labelColor}
            />
          </span>
        )}
      </div>
    );
  },
);
